import { Pipe, PipeTransform } from '@angular/core';

import { RouteLocation } from '../../../pages/overview/models/shipment';

@Pipe({
  name: 'formatRouteLocation',
  standalone: true
})
export class FormatRouteLocationPipe implements PipeTransform {
  transform(location: RouteLocation): string {
    if (location.name) {
      return this.nameWithCode(location);
    }

    return location.countryCode ? location.countryCode : location.code || '';
  }

  private nameWithCode(location: RouteLocation) {
    const name = location.name!;
    const codeInName = location.countryCode !== null && name.endsWith(location.countryCode);
    if (codeInName) {
      const nameWithoutCode = name.substring(0, name.length - location.countryCode!.length);
      return `${nameWithoutCode} (${location.countryCode})`;
    }
    return name;
  }
}
